module.exports = __webpack_public_path__ + "static/media/pda1.5ac18038.png";